import { FromSchema } from '@40seas/entities/common';
import { z } from 'zod';

export const PercentageValueSchema = z
    .object({
        percentage: z.number().optional().or(z.null()),
        value: z.number().optional().or(z.null()),
    })
    .strict();

export class PercentageValue extends FromSchema(PercentageValueSchema) {
    percentage?: number;
    value?: number;

    constructor(percentage: number, value: number) {
        super();
        this.percentage = percentage;
        this.value = value;
    }

    static fromBaseValue(percentage: number, baseValue: number): PercentageValue {
        const value = baseValue * (percentage / 100);
        return new PercentageValue(percentage, value);
    }
}
